import React from "react";
import { FieldArray, useFormikContext } from "formik";
import Select from "./FormikSelectField";
import Input from "./InputField";
import { IoCloseCircle, IoClose } from "react-icons/io5";
// import FormFieldArray from "./FormFieldArray";

const FormFieldOptionArray = ({sectionId,fieldId}) => {
    const { values } = useFormikContext();

    return (
        <FieldArray name={`formSections[${sectionId}].formFields[${fieldId}].formFieldOptions`}>
          {({ insert, remove, push }) => (
            <div>
             
              {values.formSections[sectionId].formFields[fieldId].formFieldOptions?.length > 0 &&
                values.formSections[sectionId].formFields[fieldId].formFieldOptions?.map((formFieldOption, index) => (
                  <div className="flex w-full space-x-3 items-end mb-2"  key={index}>
                      <Input
                        name={`formSections[${sectionId}].formFields[${fieldId}].formFieldOptions.${index}.fieldValue`}
                        id={`formSections[${sectionId}].formFields[${fieldId}].formFieldOptions.${index}.fieldValue`}
                        placeholder="Value"
                        label="Value"
                      />
    
                    <div className="w-16 ">
                      <button
                        type="button"
                        className=" h-10 bg-red-600 text-white w-full flex items-center justify-center"
                        onClick={() => remove(index)}
                      >
                       <IoClose/>
                      </button>
                    </div>
                  </div>
                ))}
                {/*  <button
                type="button"
                className="border border-slate-600 text-sm px-2 py-1.5 mt-2 w-full"
                onClick={() =>
                  push({fieldValue: ""})
                }
              >
                Add Option
              </button> */}
            </div>
          )}
        </FieldArray>

    )
}

export default FormFieldOptionArray
